module.exports = [{
      plugin: require('/home/travis/build/vwidjaya/vwidjaya.github.io/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/travis/build/vwidjaya/vwidjaya.github.io/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
